import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { RViewHelpernvzwiwlyoaxk as RViewHelper } from './RViewHelper.mjs';
import {
  FutureElement3o36ukl4wk2br as FutureElement,
  nativeSetDragDatar0aostqx6mw0 as nativeSetDragData,
  nativeOnDropqd3pwmgl0tbk as nativeOnDrop,
  nativeScrollIntoView1kvjsy2ddtc83 as nativeScrollIntoView,
} from './RView.commonHtml.js.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from './direct/ContainingView.commonHtml.mjs';
import {
  _Dimension___get_value__impl__urhqzr1mx919605mj8b as _Dimension___get_value__impl__urhqzr,
  Dimensions32ju1l7z4mh as Dimension,
} from '../models/data.mjs';
import { afterTimeout2ddqxaabn39mu as afterTimeout } from '../afterTimeout.mjs';
import { WeakReferencel11chldcck68 as WeakReference } from '../debugger.js.mjs';
import { checkLeakAfterDelayr9e6vxihbhwn as checkLeakAfterDelay } from '../debugger.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.tb3_1 = 0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var RViewClass;
function RView() {
  if (RViewClass === VOID) {
    class $ extends RViewHelper() {
      constructor(context) {
        super(context);
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = new (FutureElement())();
        this_0.hb4_1.v('kui');
        tmp.tb5_1 = this_0;
        this.ub5_1 = true;
        this.vb5_1 = null;
        var tmp_0 = this.db7();
        tmp_0.tah(() => {
          if (this.db7().f2())
            this.tb5_1.hb4_1.v('working');
          else
            this.tb5_1.hb4_1.w3('working');
          return Unit_instance;
        });
      }
      eb7(value) {
        super.eb7(value);
        var tmp0 = this.tb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.opacity' call
        var value_0 = value.toString();
        tmp0.fb7_1.opacity = value_0;
      }
      gb7() {
        return super.gb7();
      }
      hb7(value) {
        super.hb7(value);
        var tmp0 = this.tb5_1.zb3_1;
        // Inline function 'com.lightningkite.kiteui.views.hidden' call
        var value_0 = !value;
        tmp0.ib7_1.hidden = value_0;
        var tmp = this.rb6_1;
        var tmp0_safe_receiver = tmp instanceof RowOrCol() ? tmp : null;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.vb8();
        }
      }
      wb8() {
        return super.wb8();
      }
      xb8(value) {
        super.xb8(value);
        var tmp0 = this.tb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.visibility' call
        var value_0 = value ? 'visible' : 'hidden';
        tmp0.fb7_1.visibility = value_0;
      }
      yb8() {
        return super.yb8();
      }
      zb8(value) {
        super.zb8(value);
        var tmp = this.tb5_1;
        var tmp_0;
        var tmp_1 = value;
        if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          tmp_0 = _Dimension___get_value__impl__urhqzr(value);
        }
        var tmp1_safe_receiver = tmp_0;
        tmp.ab9('--spacing', tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString());
      }
      bb9() {
        return super.bb9();
      }
      cb9(value) {
        super.cb9(value);
        if (value)
          this.tb5_1.hb4_1.v('noInteraction');
        else
          this.tb5_1.hb4_1.w3('noInteraction');
      }
      db9(value) {
        super.db9(value);
        var tmp = this.tb5_1;
        tmp.eb9('data-debug-name', value == null ? '' : value);
      }
      fb9() {
        return super.fb9();
      }
      gb9(value) {
        super.gb9(value);
        var tmp0 = this.tb5_1.zb3_1;
        // Inline function 'com.lightningkite.kiteui.views.draggable' call
        var value_0 = !(value == null);
        tmp0.ib7_1.draggable = value_0;
        if (!(value == null)) {
          var tmp0_0 = this.tb5_1.hb4_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element = 'draggable';
          tmp0_0.v(element);
        } else {
          var tmp0_1 = this.tb5_1.hb4_1;
          // Inline function 'kotlin.collections.minusAssign' call
          var element_0 = 'draggable';
          tmp0_1.w3(element_0);
        }
        nativeSetDragData(this, value);
      }
      hb9() {
        return super.hb9();
      }
      ib9(value) {
        super.ib9(value);
        nativeOnDrop(this, value);
      }
      jb9() {
        return super.jb9();
      }
      kb9() {
        super.kb9();
        if (!(this.mb9() == null) || !(this.fb6_1 == null)) {
          var value = this.lb9();
          var tmp0 = this.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.paddingLeft' call
          var value_0 = _Dimension___get_value__impl__urhqzr(value.kb2_1).toString();
          tmp0.fb7_1.paddingLeft = value_0;
          var tmp0_0 = this.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.paddingTop' call
          var value_1 = _Dimension___get_value__impl__urhqzr(value.lb2_1).toString();
          tmp0_0.fb7_1.paddingTop = value_1;
          var tmp0_1 = this.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.paddingRight' call
          var value_2 = _Dimension___get_value__impl__urhqzr(value.mb2_1).toString();
          tmp0_1.fb7_1.paddingRight = value_2;
          var tmp0_2 = this.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.paddingBottom' call
          var value_3 = _Dimension___get_value__impl__urhqzr(value.nb2_1).toString();
          tmp0_2.fb7_1.paddingBottom = value_3;
        } else {
          // Inline function 'com.lightningkite.kiteui.views.paddingLeft' call
          this.tb5_1.bb4_1.fb7_1.paddingLeft = null;
          // Inline function 'com.lightningkite.kiteui.views.paddingTop' call
          this.tb5_1.bb4_1.fb7_1.paddingTop = null;
          // Inline function 'com.lightningkite.kiteui.views.paddingRight' call
          this.tb5_1.bb4_1.fb7_1.paddingRight = null;
          // Inline function 'com.lightningkite.kiteui.views.paddingBottom' call
          this.tb5_1.bb4_1.fb7_1.paddingBottom = null;
        }
      }
      nb9(horizontal, vertical, animate) {
        return nativeScrollIntoView(this, horizontal, vertical, animate);
      }
      ob9() {
        this.tb5_1.eb9('autofocus', 'true');
        afterTimeout(this, 100n, () => {
          this.tb5_1.pb9();
          return Unit_instance;
        });
      }
      qb9() {
        checkLeakAfterDelay(new (WeakReference())(this.tb5_1), 1000n);
        var tmp0_safe_receiver = this.tb5_1.rb9();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          checkLeakAfterDelay(new (WeakReference())(tmp0_safe_receiver), 1000n);
        }
      }
      sb9(theme) {
        if (theme.fb1_1) {
          this.tb5_1.hb4_1.v('transition');
        } else {
          this.tb5_1.hb4_1.w3('transition');
        }
        if (theme.gb1_1) {
          this.tb5_1.hb4_1.v('padded');
        } else {
          this.tb5_1.hb4_1.w3('padded');
        }
        var tmp0_safe_receiver = this.vb5_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this.tb5_1.hb4_1.w3(tmp0_safe_receiver);
        }
        var newClass = this.pc().ob3_1.ab2(theme.eb1_1);
        this.vb5_1 = newClass;
        this.tb5_1.hb4_1.v(newClass);
        var tmp = this.tb5_1;
        var tmp1_safe_receiver = this.rb6_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.tb9();
        var tmp_0;
        var tmp_1 = tmp2_safe_receiver;
        if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          tmp_0 = _Dimension___get_value__impl__urhqzr(tmp2_safe_receiver);
        }
        var tmp3_safe_receiver = tmp_0;
        var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
        tmp.ab9('--parentSpacing', tmp4_elvis_lhs == null ? '0px' : tmp4_elvis_lhs);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.flushClasses' call
        this.tb5_1;
      }
      ub9(index, view) {
        this.tb5_1.vb9(index, view.tb5_1);
      }
      wb9(index) {
        this.tb5_1.xb9(index);
      }
      yb9() {
        this.tb5_1.zb9();
      }
    }
    initMetadataForClass($, 'RView');
    RViewClass = $;
  }
  return RViewClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  RView as RView1jxdnn5qf89cm,
};
//endregion

//# sourceMappingURL=RView.commonHtml.mjs.map
